import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerTitleService } from '../../services/wealthlane-customer-services';

const useGetCustomerTitleList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const CustomerTitleList = useQuery(
    ['getCustomerTitle'],
    async () => {
      return await handleRequest(
        CustomerTitleService.getApiCustomerApiAppCustomerTitleCustomerTitleList()
      );
    },

    {
      select: (data) => {
        return data?.items?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return CustomerTitleList;
};

export default useGetCustomerTitleList;
